
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputComponent from '../InputComponent';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';

import DropDownList from '../DropDownList';

import { getUIText, generateUid, getUniqueName } from '../../utils/index';

import { ENERGY } from '../../modules/data/energy';

const defaultItem = {
  'custom': 'true',
  'name': '',
  'CO2-emission-per-W': 1,
};

class EnergySource extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: null,
    };
  }

  onCreateNewItem() {
    const { translations, app, create, items} = this.props;

    const newItem = {
      ...defaultItem,
      name: getUniqueName(items, getUIText('SETTINGS-CUSTOM_ENERGY_SOURCE_HEADER', app.language, translations)),
      Nid: generateUid()
    };

    this.setState({
      id: newItem.Nid
    });

    create({item: newItem, type: ENERGY});
  }

  onDeleteItem(id, e) {
    const { items, remove } = this.props;
    if(items) {
      const index = items.findIndex( (item ) => {
        if(item.Nid === id) {
          return true;
        }
        return false;
      });

      const newItems = [
        ...items.slice(0, index),
        ...items.slice(index + 1)
      ];

      let newId = '-1';
      if(newItems[index]) {
        newId = newItems[index].Nid;
      } else if (newItems[index - 1]) {
        newId = newItems[index - 1].Nid;
      }

      remove({id: items[index].Nid, type: ENERGY});
      this.setState({
        id: newId
      });
    }
  }

  onPatchItem(id, updateItem, e) {
    const { items, patch } = this.props;

    if(items) {
      const updatedItem = items.find( item => {
        if(item.id === id) {
          return true;
        }
        return false;
      });
      patch({item: updateItem, type: ENERGY});
    }
  }

  render() {
    const { translations, app, items} = this.props;

    let data = [];
    if(items) {
      data = items.filter( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return true;
        }
      });
    }

    data = data.map( item => {
      return {...item, id: item.Nid};
    });

    const selectedItem = data.find( (item) => {
      if(item.Nid === this.state.id) {
        return true;
      }
      return false;
    });

    return (
      <div className="settings-product">
        <Grid container spacing={8}>
          <Grid item xs={6} className="setting-dropdownlist-container">
            <DropDownList
              className="setting"
              data={data}
              selectedItem={this.state.id}
              label={getUIText('SETTINGS-CUSTOM_ENERGY_SOURCES', app.language, translations)}
              onChange={ (id) => {this.setState({id: id});} } />
          </Grid>
          <Grid item xs={6} className="setting-dropdownlist-container">
            <div className="settings-buttons" >
              <Button color="primary" onClick={this.onCreateNewItem.bind(this)} >{getUIText('GENERAL-NEW', app.language, translations)}</Button>
              <Button color="primary" disabled={this.state.id ? false : true} onClick={this.onDeleteItem.bind(this, this.state.id)} >{getUIText('GENERAL-DELETE', app.language, translations)}</Button>
            </div>
          </Grid>
          {selectedItem ? <Grid item xs={12} md={6}>
            <InputComponent
              label={getUIText('SETTINGS-PRODUCT_NAME', app.language, translations)}
              value={selectedItem ? selectedItem['name'] : ''}
              type="string"
              className="full-width settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'name': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-CO2-EMISSION', app.language, translations)}
              value={selectedItem ? selectedItem['CO2-emission-per-W'] : ''}
              type="number"
              unit="CO2 g/kWh"
              className="settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'CO2-emission-per-W': value})}
              />
          </Grid> : null }
        </Grid>
      </div>
    );
  }
}

EnergySource.propTypes = {

  translations: PropTypes.any,
  app: PropTypes.any,
  create: PropTypes.any,
  items: PropTypes.any,
  remove: PropTypes.any,
  patch: PropTypes.any,
};

export default EnergySource;
